//#region Imports
import { IsoWeekday, IsoWeekdayT, UserSettingsRecordSelectedImage, UserSettingsTheme } from "@anydo/interfaces";
//#endregion

// Used for records that yet to be sync with server
export const NOT_INITIALIZED_ID = "NOT_INITIALIZED_ID";

export const CATEGORY_NAME_MAX_LENGTH = 1000;
export const BOARD_NAME_MAX_LENGTH = 1000;
export const WORKSPACE_NAME_MAX_LENGTH = 100;
export const SECTION_NAME_MAX_LENGTH = 1000;
export const CUSTOM_VIEW_NAME_MAX_LENGTH = 100;

//#region Session
export const INSTALLATION_ID_LS_KEY = "installationId";
/** Versions change are session changes */
export const SESSION_ID_SS_KEY = `anydo-session-id:${process.env.REACT_APP_ANYDO_VERSION}`;
//#endregion

//#region Analytics
export const ANALYTICS_APP_PLATFORM_WEB_EXTENSION = 2;
export const ANALYTICS_APP_PLATFORM_WEB_APP = 3;
export const ANALYTICS_APP_PLATFORM_PACKAGED_APP = 4; // Chrome app (deprecated?)
export const ANALYTICS_APP_PLATFORM_MAC_APP = 5;
//#endregion

//#region URLs
export const ANYDO_WHATSAPP_SUPPORT_DOMAIN = "https://support.any.do/whatsapp-reminders/";
//#endregion

//#region Migration
export const DOMAIN_MIGRATION_QUERY_PARAMS = {
  AUTH_TOKEN: "adm_t",
  USER_SETTINGS: "adm_us",
};
//#endregion

//#region Tasks
export const TASK_TITLE_MAX_LENGTH = 1000;
export const TASK_NOTE_MAX_LENGTH = 65535;
export const TASK_DUE_DATE_GROUP_UPCOMING_IN_DAYS = 7;
export const TASK_DUE_DATE_HOUR_FOR_TOMORROW_AND_UPCOMING_GROUPS = 9;
//#endregion

//#region Card
export const CARD_TITLE_MAX_LENGTH = 1000;
export const CARD_NOTE_MAX_LENGTH = 65535;

export const CARD_CHECKLIST_ITEM_TITLE_MAX_LENGTH = 500;
//#endregion

//#region Tag
export const TAG_NAME_MAX_LENGTH = 100;
//#endregion

//#region Label
export const LABEL_NAME_MAX_LENGTH = 60;
//#endregion

//#region Premium campaign
export const GET_PREMIUM_QUERY_PARAM = "get-premium";
//#endregion

//#region Auth query params
export const AUTH_TOKEN_QUERY_PARAM = "token";
//#endregion

//#region Calendar
export const CALENDAR_SELECTIONS_USS_KEY = "calendar:calendars-selections";
export const CALENDAR_SHOULD_AUTO_LOGIN_USS_KEY = "calendar:should-auto-login";
//#endregion

//#region Time & Date
export const DEFAULT_WEEK_START_DAY: IsoWeekdayT = IsoWeekday.MONDAY;
//#endregion

//#region Background
// We use more generic types, because code implementations shouldn't be related to specific image
export const DEFAULT_USER_SETTINGS_SELECTED_IMAGE: UserSettingsRecordSelectedImage =
  UserSettingsRecordSelectedImage.IMAGE_37;

export const MYDAY_ROUTE_BLANK_IMAGE: UserSettingsRecordSelectedImage =
  //
  UserSettingsRecordSelectedImage.BLANK;

export const NONE_PREMIUM_USER_SETTINGS_SELECTED_IMAGES: ReadonlySet<UserSettingsRecordSelectedImage> = new Set([
  //
  UserSettingsRecordSelectedImage.BLANK,
  UserSettingsRecordSelectedImage.NONE,
  UserSettingsRecordSelectedImage.IMAGE_21,
  UserSettingsRecordSelectedImage.IMAGE_31,
]);

export const USER_SETTINGS_SELECTED_IMAGE_NO_IMAGE: ReadonlySet<UserSettingsRecordSelectedImage> = new Set([
  //
  UserSettingsRecordSelectedImage.NONE,
]);

// NOTE: The order is the order of the preview
export const BACKGROUND_IMAGES: ReadonlyArray<UserSettingsRecordSelectedImage> = [
  UserSettingsRecordSelectedImage.IMAGE_31,
  UserSettingsRecordSelectedImage.IMAGE_32,
  UserSettingsRecordSelectedImage.IMAGE_33,
  UserSettingsRecordSelectedImage.IMAGE_34,
  UserSettingsRecordSelectedImage.IMAGE_35,
  UserSettingsRecordSelectedImage.IMAGE_36,
  UserSettingsRecordSelectedImage.IMAGE_37,
];

export const BACKGROUND_IMAGES_SVG: ReadonlyArray<UserSettingsRecordSelectedImage> = [
  UserSettingsRecordSelectedImage.IMAGE_33,
  UserSettingsRecordSelectedImage.IMAGE_34,
  UserSettingsRecordSelectedImage.IMAGE_35,
];
//#endregion

//#region User theme
export const DEFAULT_USER_SETTINGS_THEME: UserSettingsTheme = UserSettingsTheme.AUTO;
//#endregion

//#region User addedFirstMyDayEntry
export const DEFAULT_ADDED_FIRST_MY_DAY_ENTRY = false;
//#endregion

//#region User Sticky Videos Dismissed
export const DEFAULT_IS_STICKY_VIDEO_DISMISSED = false;
//#endregion

// 0 because the webconfig doesn't accept nulls and undefined as valid values
export const DEFAULT_MAC_STORE_LAST_INVOCATION_TIMESTAMP = 0;

//#region User Expanded Card Tags
export const DEFAULT_IS_EXPANDED_CARD_TAGS = true;
//#endregion

//#region Keyboard shortcuts
export const KEYBOARD_SHORTCUT_CLOSE_MODAL = "escape";
export const KEYBOARD_SHORTCUT_ARROW_UP = "ArrowUp";
export const KEYBOARD_SHORTCUT_ARROW_DOWN = "ArrowDown";
export const KEYBOARD_SHORTCUT_ENTER = "Enter";
//#endregion

//#region CSS
export const LIGHT_THEME_CLASSNAME = "u-anydo-light-theme";
export const DARK_THEME_CLASSNAME = "u-anydo-dark-theme";
export const IN_DND_UTIL_CLASS_NAME = "u-anydo-inDnD";
export const IN_DND_ANIMATION_UTIL_CLASS_NAME = "u-anydo-inDnDAnimation";

export const TASK_DROP_ANIMATION = {
  duration: 200,
  easing: "ease-in",
  dragSourceOpacity: 0, // makes sure drag placeholder fades out till drag overlay overlaps it
};
//#endregion

//#region document.title
export const DOCUMENT_TITLE_CACHE_LS_KEY = "anydo-document-title-cache";
//#endregion

export const DEFAULT_MYDAY_RESET_HOUR_OF_DAY = "0000";

//#region file attachment
export const FREE_ACCOUNT_FILE_SIZE_LIMIT = 1024 * 1024 * 1.5;
export const PREMIUM_ACCOUNT_FILE_SIZE_LIMIT = 1024 * 1024 * 100;
export const TEAMS_FILE_SIZE_LIMIT = 1024 * 1024 * 100;
//#endregion

export const DEFAULT_MULTICOLUMN_ENTITY_TYPE = "task";

export const EMPTY_TAGS_FAKE_ID = "";
export const EMPTY_TAGS_I18N_KEY = "_.tags.noTags";
